(() => {
  const stage = document.querySelector('[data-wk-frost]');
  if (!stage) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const canvas = stage.querySelector('canvas');
  const hint = stage.querySelector('[data-wk-hint]');
  const clearButton = stage.querySelector('[data-wk-clear]');
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  if (!ctx) return;

  let drawing = false;
  let last = null;
  let decided = false;
  let horizontal = false;
  let queued = false;
  let pending = null;

  const frost = getComputedStyle(document.documentElement).getPropertyValue('--frost').trim() || '#dcebf2';

  function paint() {
    const rect = stage.getBoundingClientRect();
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.max(1, Math.round(rect.width * dpr));
    canvas.height = Math.max(1, Math.round(rect.height * dpr));
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    ctx.fillStyle = frost;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height);
    for (let i = 0; i < pixels.data.length; i += 16) {
      const grain = (Math.random() * 28) | 0;
      pixels.data[i] = Math.min(255, pixels.data[i] + grain);
      pixels.data[i + 1] = Math.min(255, pixels.data[i + 1] + grain);
      pixels.data[i + 2] = Math.min(255, pixels.data[i + 2] + grain);
    }
    ctx.putImageData(pixels, 0, 0);
    canvas.style.opacity = '0.85';
  }

  function point(event) {
    const rect = canvas.getBoundingClientRect();
    const dpr = canvas.width / rect.width;
    return {
      x: (event.clientX - rect.left) * dpr,
      y: (event.clientY - rect.top) * dpr,
    };
  }

  const brush = 72;

  function erase(from, to) {
    const rect = canvas.getBoundingClientRect();
    const dpr = canvas.width / rect.width;
    ctx.globalCompositeOperation = 'destination-out';
    ctx.strokeStyle = '#000';
    ctx.lineWidth = brush * dpr;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.beginPath();
    ctx.moveTo(from.x, from.y);
    ctx.lineTo(to.x, to.y);
    ctx.stroke();
  }

  function drawQueued() {
    queued = false;
    if (!pending || !last) return;
    erase(last, pending);
    last = pending;
    pending = null;
  }

  function clearedEnough() {
    const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    let total = 0;
    let open = 0;
    const count = canvas.width * canvas.height;
    for (let pixel = 0; pixel < count; pixel += 8) {
      total += 1;
      if (pixels[pixel * 4 + 3] < 20) open += 1;
    }
    return total > 0 && open / total >= 0.45;
  }

  function fade() {
    stage.classList.add('is-gone');
    if (hint) hint.hidden = true;
    if (clearButton) clearButton.hidden = true;
  }

  paint();
  window.addEventListener('resize', paint);

  canvas.addEventListener('pointerdown', (event) => {
    drawing = true;
    decided = false;
    horizontal = false;
    last = point(event);
    canvas.setPointerCapture(event.pointerId);
  });

  canvas.addEventListener('pointermove', (event) => {
    if (!drawing) return;
    const next = point(event);
    if (!decided && last) {
      const dx = Math.abs(next.x - last.x);
      const dy = Math.abs(next.y - last.y);
      if (dx + dy > 6) {
        decided = true;
        horizontal = dx > dy;
      }
    }
    if (!horizontal) return;
    if (event.cancelable) event.preventDefault();
    pending = next;
    if (!queued) {
      queued = true;
      requestAnimationFrame(drawQueued);
    }
  });

  function finish() {
    if (!drawing) return;
    drawing = false;
    if (horizontal && clearedEnough()) fade();
  }

  canvas.addEventListener('pointerup', finish);
  canvas.addEventListener('pointercancel', finish);
  if (clearButton) clearButton.addEventListener('click', fade);
})();
